import {restore, Domain} from 'effector';

import {rootDomain} from 'core/rootDomain';
import {ApiSortings, InnerFilters} from 'types/api';

export function createListModel({
    defaultFilters = [],
    defaultSorting = [],
    domain = rootDomain.createDomain(),
}: {
    defaultFilters?: InnerFilters;
    defaultSorting?: ApiSortings;
    domain: Domain;
}) {
    const pageNumberChanged = domain.createEvent<number>('pageNumberChanged');
    const pageSizeChanged = domain.createEvent<number>('pageSizeChanged');
    const sortingChanged = domain.createEvent<ApiSortings>('sortingChanged');
    const filtersChanged = domain.createEvent<InnerFilters>('filtersChanged');
    const pageIncremented = domain.createEvent('pageIncremented');

    const pageNumber$ = restore(pageNumberChanged, 0);
    const pageSize$ = restore(pageSizeChanged, 30);
    const sorting$ = restore(sortingChanged, defaultSorting);
    const filters$ = restore(filtersChanged, defaultFilters);

    return {
        pageNumber$,
        pageNumberChanged,
        pageIncremented,
        pageSize$,
        pageSizeChanged,
        filters$,
        filtersChanged,
        sorting$,
        sortingChanged,
    };
}
